import { UIText2, Image, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatHeaderPinFilter.css';
import { IChatbotMessageInfoBlockSchema } from '../../../types/chatbot';

type TChatHeaderOffer = {
  pinFilter: IChatbotMessageInfoBlockSchema;
  onClick: () => void;
};

const ChatHeaderPinFilterComponent: React.FC<TChatHeaderOffer> = ({ pinFilter, onClick }) => {
  return (
    <div className={styles['container']} data-testid="chat_header_pin_filter" onClick={onClick}>
      {pinFilter.imageUrl && (
        <Image width={40} height={40} objectFit="cover" src={pinFilter.imageUrl} data-testid="image" />
      )}
      <div className={styles['info']}>
        <UIText2 fontWeight="700">{pinFilter.title}</UIText2>
        <UIText3 color="text-secondary-default">{pinFilter.subtitle}</UIText3>
      </div>
    </div>
  );
};

export const ChatHeaderPinFilter = React.memo(ChatHeaderPinFilterComponent);
